import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { isDemoMode } from '../demo/core';

export interface KPILimit {
  id: string;
  name: string;
  value: number;
  operator: '>' | '<' | '=' | '>=' | '<=';
  alertMessage: string;
  isEnabled: boolean;
}

interface KPIStore {
  limits: KPILimit[];
  addLimit: (limit: KPILimit) => void;
  updateLimit: (id: string, limit: Partial<KPILimit>) => void;
  removeLimit: (id: string) => void;
  toggleLimit: (id: string) => void;
}

export const useKPIStore = create<KPIStore>()(
  persist(
    (set) => ({
      limits: [],
      addLimit: (limit) =>
        set((state) => ({
          limits: [...state.limits, limit],
        })),
      updateLimit: (id, limit) =>
        set((state) => ({
          limits: state.limits.map((l) =>
            l.id === id ? { ...l, ...limit } : l
          ),
        })),
      removeLimit: (id) =>
        set((state) => ({
          limits: state.limits.filter((l) => l.id !== id),
        })),
      toggleLimit: (id) =>
        set((state) => ({
          limits: state.limits.map((l) =>
            l.id === id ? { ...l, isEnabled: !l.isEnabled } : l
          ),
        })),
    }),
    {
      name: 'kpi-limits',
      // Demo tabs keep KPI limits per tab (sessionStorage) so they reset with the
      // demo and never leak into / out of a real session's localStorage. The store
      // is created after DemoEntry's reload, so the flag is already set.
      storage: createJSONStorage(() => (isDemoMode() ? sessionStorage : localStorage)),
    }
  )
); 